module.exports = __webpack_public_path__ + "img/titlebgdj.9201ac58.png";